var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnsupervisedLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF5502;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unsupervised-Learning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unsupervised-Learning"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    className: "st0",
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,50.3h3v10.9c0,1.1-0.3,2.2-0.9,3.2c-0.6,0.9-1.4,1.7-2.4,2.1c-1.1,0.5-2.3,0.8-3.6,0.8 c-1.2,0-2.5-0.2-3.6-0.8c-1-0.5-1.8-1.2-2.4-2.1c-0.6-1-0.9-2-0.8-3.2V50.3h3V61c0,0.7,0.1,1.3,0.5,1.9c0.3,0.5,0.8,1,1.3,1.3 c0.6,0.3,1.3,0.5,2,0.5c0.7,0,1.4-0.1,2-0.5c0.5-0.3,1-0.7,1.3-1.3c0.3-0.6,0.5-1.2,0.5-1.9V50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.6,67.1V50.3h3v14.2H79v2.5H68.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupervisedLearning);
export default __webpack_public_path__ + "static/media/UnsupervisedLearning.524001763b807064e2418c96df7126cf.svg";
export { ForwardRef as ReactComponent };